const initInfiniteScroll = () => {
  const containers = document.querySelectorAll('[data-infinite-scroll]');
  if (!containers.length) return;

  containers.forEach((container) => {
    const sentinel = container.querySelector('.load-more-sentinel');
    if (!sentinel) return;

    let loading = false;
    let page = parseInt(container.dataset.page, 10) || 1;
    let hasMore = container.dataset.hasMore === 'true';
    const archiveType = container.dataset.archiveType || '';
    const filters = container.dataset.filters
      ? JSON.parse(container.dataset.filters)
      : {};
    const contentTarget = container.dataset.contentTarget
      ? container.querySelector(container.dataset.contentTarget)
      : null;

    if (!hasMore || !archiveType) {
      sentinel.remove();
      return;
    }

    const loadMore = async () => {
      if (loading || !hasMore) return;
      loading = true;

      const nextPage = page + 1;
      const formData = new FormData();
      formData.append('action', 'air_light_load_more');
      formData.append('nonce', window.airLightLoadMore.nonce);
      formData.append('archive_type', archiveType);
      formData.append('page', nextPage);
      formData.append('filters', JSON.stringify(filters));
      if (window.airLightLoadMore && window.airLightLoadMore.lang) {
        formData.append('lang', window.airLightLoadMore.lang);
      }

      try {
        const response = await fetch(window.airLightLoadMore.ajaxUrl, {
          method: 'POST',
          body: formData,
        });

        const data = await response.json();

        if (data.success && data.data.html) {
          const temp = document.createElement('div');
          temp.innerHTML = data.data.html;

          if (contentTarget) {
            while (temp.firstChild) {
              contentTarget.appendChild(temp.firstChild);
            }
          } else {
            while (temp.firstChild) {
              sentinel.parentNode.insertBefore(temp.firstChild, sentinel);
            }
          }

          page = nextPage;
          container.dataset.page = page;
        }

        hasMore = data.success && data.data.has_more;
        container.dataset.hasMore = hasMore ? 'true' : 'false';

        if (!hasMore) {
          sentinel.remove();
        }
      } catch {
        // Network error — sentinel stays visible so user can retry on next scroll
      }

      loading = false;
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadMore();
          }
        });
      },
      { rootMargin: '200px' }
    );

    observer.observe(sentinel);
  });
};

export default initInfiniteScroll;
